import "./partyShell.css";

import Box from "@mui/material/Box";
import React from "react";
import { Outlet } from "react-router-dom";

import { PartyShellProvider, usePartyShell } from "./PartyShellContext";

function PartyShellFrame() {
  const { tweaks, toast } = usePartyShell();

  return (
    <Box
      className="party-shell-root"
      dir="rtl"
      lang="ar"
      data-party-theme={tweaks.theme}
      data-party-type={tweaks.type}
      sx={
        {
          "--motion": String(tweaks.motion),
        } as React.CSSProperties
      }
    >
      <Box className="party-app-frame">
        <Outlet />
      </Box>
      {toast ? <Box className="party-toast">{toast}</Box> : null}
      {/* <PartyTweaksPanel open={tweaksOpen} state={tweaks} setState={setTweaks} /> */}
    </Box>
  );
}

/** Full-bleed party shell (kan.html). Uses existing login; catalog and games when signed in. */
export default function PartyLayout() {
  return (
    <PartyShellProvider>
      <PartyShellFrame />
    </PartyShellProvider>
  );
}
